import { NotAuthorized } from "_shared/_errors/_views/not-authorized";
import { RootState, useAttorneyHubDispatch } from "_shared/_stores/redux-store";
import CompanyBookmarks from "marketplace/bookmarks/company-bookmarks/_views/company-bookmarks-table";
import IndividualBookmarks from "marketplace/bookmarks/individual-bookmarks/_views/individual-bookmarks-table";
import TeamBookmarks from "marketplace/bookmarks/team-bookmarks/_views/team-bookmarks-table";
import { getSessionPermissions, populateSessionPermissions } from "permissions/_stores/permissions-redux-slice";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLoaderData, useSearchParams } from "react-router";
import { useSession } from "users/__session/session-context";
import { PageTab } from "./bookmarks-page-tabs";

export default function Bookmarks() {
  const [activeTab, setActiveTab] = React.useState(PageTab.Individual);

  const tabFromUrl = useLoaderData();
  const [searchParams] = useSearchParams();
  const session = useSession();
  const dispatch = useAttorneyHubDispatch();
  const sessionPermissions = useSelector(getSessionPermissions);
  const sessionPermissionsLoading = useSelector((state: RootState) => state.permissions.session.loading);
  const sessionPermissionsError = useSelector((state: RootState) => state.permissions.session.error);

  useEffect(() => {
    if (!sessionPermissions && !sessionPermissionsError && !sessionPermissionsLoading) {
      dispatch(populateSessionPermissions({ session }));
    }
  }, [sessionPermissions, sessionPermissionsError, sessionPermissionsLoading]);

  // Handle URL changes
  useEffect(() => {
    if (tabFromUrl) setActiveTab(tabFromUrl as PageTab);
  }, [searchParams, tabFromUrl]);

  if (!sessionPermissions?.includesAccessToMarketplace) return <NotAuthorized />;

  return (
    <>
      {activeTab === PageTab.Individual && <IndividualBookmarks activeTab={activeTab} />}
      {activeTab === PageTab.Team && <TeamBookmarks activeTab={activeTab} />}
      {activeTab === PageTab.Company && <CompanyBookmarks activeTab={activeTab} />}
    </>
  );
}
